<div edsGrid [ngClass]="{ 'has-edit-button': page.isPreview() }">
  <ng-container
    *ngIf="page.isPreview()"
    [brManageContentButton]="document"
    documentTemplateQuery="new-Accordion-document"
    folderTemplateQuery="new-Accordion-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>

  <div class="{{ container }}" *ngIf="accordionDocument">
    <div [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom">
      <!-- Title -->
      <div *ngIf="accordionDocument.title?.title">
        <div edsRow>
          <eds-title
            edsCol
            edsSpacing="md"
            theme="dark"
            [level]="2"
            [size]="'h3'"
            [theme]="titleColor"
            >{{ accordionDocument.title.title }}</eds-title
          >
        </div>
      </div>

      <!-- Summary -->
      <div *ngIf="accordionDocument.summary?.value">
        <div edsRow>
          <div
            edsCol
            edsSpacing="md"
            [innerHTML]="accordionDocument.summary.value"
          ></div>
        </div>
      </div>

      <!-- accordion content -->
      <div *ngIf="accordion" edsRow>
        <eds-accordion edsCol>
          <eds-accordion-item
            *ngFor="let accordionBlock of this.accordion; let i = index"
            [id]="accordionBlock?.id"
            [title]="accordionBlock.title"
            [secondaryTitle]="accordionBlock.secondaryTitle"
            [context]="{ index: i }"
            (selected)="selected($event)"
          >
            <div
              edsSpacing="lg"
              class="ck-editor"
              [innerHTML]="accordionBlock.content.value | safeHtml"
            ></div>

            <!-- New content block option -->
            <div
              *ngFor="let contentBlock of accordionBlock.accordionBlocks"
              [ngSwitch]="contentBlock.contentType"
            >
              <ng-template ngSwitchCase="ftcore:TitleBlock">
                <ft-title-block [content]="contentBlock"></ft-title-block>
              </ng-template>

              <ng-template ngSwitchCase="ftcore:ParagraphBlock">
                <ft-text-block [content]="contentBlock"></ft-text-block>
              </ng-template>

              <ng-template ngSwitchCase="ftcore:ContentBlock">
                <ft-one-col-block
                  [contentBlock]="contentBlock"
                  [page]="page"
                  spacing="lg"
                ></ft-one-col-block>
              </ng-template>

              <ng-template ngSwitchCase="ftcore:TwoColumnBlock">
                <ft-two-col-block
                  [contentBlock]="contentBlock"
                  [page]="page"
                  spacing="lg"
                ></ft-two-col-block>
              </ng-template>

              <ng-template ngSwitchDefault>
                <ft-image-block [content]="contentBlock"></ft-image-block>
              </ng-template>
            </div>
          </eds-accordion-item>
        </eds-accordion>

        <ng-container>
          <ng-template
            *ngFor="let accordionNgBlock of this.accordion"
            let-index="index"
          >
            {{ accordionNgBlock.title }}
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- no document -->
<div *ngIf="!accordionDocument && page.isPreview()" class="no-document">
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Accordion</strong>
    </div>
  </div>
</div>
